var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9214 12.7628C20.7796 12.4495 20.4681 12.25 20.1251 12.25H16.6251V0.875C16.6251 0.392 16.2331 0 15.7501 0H12.2501C11.7671 0 11.3751 0.392 11.3751 0.875V12.25H7.87511C7.53211 12.25 7.22061 12.4513 7.07886 12.7628C6.93536 13.076 6.99136 13.4417 7.21711 13.7008L13.3421 20.7008C13.5084 20.8915 13.7481 21 14.0001 21C14.2521 21 14.4919 20.8898 14.6581 20.7008L20.7831 13.7008C21.0106 13.4435 21.0631 13.076 20.9214 12.7628Z",
    fill: "#3F4857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 19.25V24.5H4.375V19.25H0.875V26.25C0.875 27.2178 1.659 28 2.625 28H25.375C26.3428 28 27.125 27.2178 27.125 26.25V19.25H23.625Z",
    fill: "#3F4857"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.a43c5751.svg";
export { ForwardRef as ReactComponent };